package com.eladfinish.bible.contest.screens.americanQuestions.menu

import androidx.compose.runtime.Composable
import com.eladfinish.bible.contest.SharedRes
import com.eladfinish.bible.contest.fifty_fifty
import com.eladfinish.bible.contest.help
import com.eladfinish.bible.contest.menu_refresh
import com.eladfinish.bible.contest.title_activity_settings
import com.eladfinish.bible.contest.ui.components.toolbar.SetToolbarConfiguration
import com.eladfinish.bible.contest.ui.components.toolbar.configuration.model.ToolbarActionConfig
import com.eladfinish.bible.contest.ui.components.toolbar.configuration.model.ToolbarActionPlacement
import com.eladfinish.bible.contest.ui.components.toolbar.configuration.model.ToolbarConfiguration
import com.eladfinish.bible.contest.ui.components.toolbar.configuration.model.ToolbarHeaderComponentConfig
import com.eladfinish.bible.contest.ui.components.toolbar.model.ToolbarKind
import com.eladfinish.bible.contest.ui.menus.actions.MultipleChoiceQuestionsToolbarAction
import com.eladfinish.bible.contest.ui.menus.actions.ToolbarActionEmitter
import dev.icerock.moko.resources.desc.desc
import kotlinx.collections.immutable.persistentListOf

enum class MultipleChoiceToolbarId {
    FIFTY_FIFTY,
    HELP,
    REFRESH,
    ADD_QUESTION,
    SETTINGS,
}

@Composable
internal fun MultipleChoiceQuestionsMenu(
    title: String,
    toolbarEmitter: ToolbarActionEmitter<MultipleChoiceQuestionsToolbarAction>,
) {
    SetToolbarConfiguration(
        configuration = ToolbarConfiguration(
            kind = ToolbarKind.MultipleChoice,
            title = ToolbarHeaderComponentConfig.Text(
                text = title,
            ),
            actions = persistentListOf(
                ToolbarActionConfig.TextActionRes(
                    id = MultipleChoiceToolbarId.FIFTY_FIFTY,
                    stringDesc = SharedRes.strings.fifty_fifty.desc(),
                    onClick = { toolbarEmitter.emit(action = MultipleChoiceQuestionsToolbarAction.FiftyFifty) },
                    placement = ToolbarActionPlacement.OnToolbar,
                ),
                ToolbarActionConfig.TextActionRes(
                    id = MultipleChoiceToolbarId.HELP,
                    stringDesc = SharedRes.strings.help.desc(),
                    onClick = { toolbarEmitter.emit(action = MultipleChoiceQuestionsToolbarAction.Help) },
                    placement = ToolbarActionPlacement.InOverflow,
                ),
                ToolbarActionConfig.TextActionRes(
                    id = MultipleChoiceToolbarId.REFRESH,
                    stringDesc = SharedRes.strings.menu_refresh.desc(),
                    onClick = { toolbarEmitter.emit(action = MultipleChoiceQuestionsToolbarAction.Refresh) },
                    placement = ToolbarActionPlacement.InOverflow,
                ),
                ToolbarActionConfig.TextActionRes(
                    id = MultipleChoiceToolbarId.SETTINGS,
                    stringDesc = SharedRes.strings.title_activity_settings.desc(),
                    onClick = { toolbarEmitter.emit(action = MultipleChoiceQuestionsToolbarAction.Settings) },
                    placement = ToolbarActionPlacement.InOverflow,
                ),
            )
        )
    )
}
